const ProductFooter = () => {
  return (
    <div>ProductFooter</div>
  )
}

export default ProductFooter